import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { FormCheck, Button } from 'react-bootstrap';
import ApiService from '../../services/ApiService';
import { modal } from '../modal/ModalEmitter';
import FileNotFound from '../FileNotFound';

const getDisplayName = (user = {}) => {
  if (user.displayName) {
    return user.displayName;
  }

  return `${user.firstName} ${user.lastName}`.trim() || user.username;
};

const QuoteListItem = ({ quote, onCheck, onUncheck, initial = false }) => {
  const [checked, setChecked] = useState(initial);

  const handleRowClick = () => {
    setChecked(prev => !prev);
  };

  useEffect(() => {
    if (checked) {
      onCheck(quote.id);
    } else {
      onUncheck(quote.id);
    }
  }, [checked]);

  return (
    <tr className="quote-list-item" onClick={handleRowClick}>
      <td width="15">
        <FormCheck className="pl-1">
          <FormCheck.Input type="checkbox" onChange={() => {}} checked={checked} />
        </FormCheck>
      </td>
      <td>
        <div className="quote-id" title={quote.id}>
          <i className="fas fa-square mr-1" style={{ color: _.get(quote, 'QuoteState.color', '#333') }} />Q{quote.id}
        </div>
      </td>
      <td>{quote.vehicleId}</td>
      <td>{getDisplayName(quote.AssignedTo)}</td>
    </tr>
  );
};

const BatchActions = ({ quoteList, dealId, fetchDeal }) => {
  const [selectedQuotes, setSelectedQuotes] = useState([]);
  const [key, setKey] = useState(1);

  const filtered = quoteList.filter(quote => _.get(quote, 'QuoteState.logicalName') === 'OPEN');

  const onCheck = quoteId => {
    setSelectedQuotes([...new Set([quoteId, ...selectedQuotes])]);
  };

  const onUncheck = quoteId => {
    setSelectedQuotes(selectedQuotes.filter(id => id !== quoteId));
  };

  const handleSelectAll = () => {
    const filtered = quoteList.filter(quote => _.get(quote, 'QuoteState.logicalName') === 'OPEN');

    setSelectedQuotes([...filtered.map(q => q.id)]);
    incrementKey();
  };

  const incrementKey = () => {
    setKey(prev => prev + 1);
  };

  const handleSubmit = () => {
    ApiService.put('crm/quotes/batch-cancel', { quotes: selectedQuotes }).then(() => {
      fetchDeal();
      modal.close();
    });
  };

  const renderQuoteList = () => {
    if (!filtered.length) {
      return <FileNotFound>No Open Quotes Found</FileNotFound>;
    }

    return (
      <table>
        <tbody>
          {filtered.map(quote => {
            return (
              <QuoteListItem
                key={`${quote.id}-${key}`}
                quote={quote}
                onCheck={onCheck}
                onUncheck={onUncheck}
                initial={selectedQuotes.includes(quote.id)}
              />
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <div className="batch-actions">
      <div className="batch-action-toolbar text-right mb-2">
        {filtered.length > 0 && (
          <Button size="sm" onClick={handleSelectAll}>
            Select All
          </Button>
        )}
      </div>
      <div className="quote-list">{renderQuoteList()}</div>
      <div className="batch-action-control text-right mr-1">
        {filtered.length > 0 ? (
          <Button variant="danger" disabled={!selectedQuotes.length} onClick={handleSubmit}>
            Cancel Selected
          </Button>
        ) : (
          <Button variant="secondary" onClick={modal.close}>
            Close
          </Button>
        )}
      </div>
    </div>
  );
};

export default BatchActions;
